const BuyingHistory = () => import('@/views/main/live/buyingHistoryAfterSales/BuyingHistory.vue')
export default {
  path: '/main/live/buyingHistoryAfterSales',
  name: 'BuyingHistoryAfterSales',
  component: BuyingHistory,
  children: []
}
